import { Config, Maybe } from '~types/appsync.types';

const getConfigKeyValue = (config: Maybe<Config> | undefined, key: string): string | undefined => {
  const foundKey = config?.configKeys.find((configKey) => configKey.id === key);
  return foundKey?.value;
};

export const getIntConfigKeyValue = (
  config: Maybe<Config> | undefined,
  key: string,
  defaultValue?: number,
): number | undefined => {
  const foundValue: string | undefined = getConfigKeyValue(config, key);
  return foundValue ? Number.parseInt(foundValue) : defaultValue;
};
